/**
 * ISO 639-1 language codes (two-letter codes)
 * Source: https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 */

/** Primary / frequent languages prioritized at the top of the list */
export const POPULAR_ISO639_1 = [
  "ko", // Korean
  "en", // English
  "ja", // Japanese
  "zh", // Chinese
  "es", // Spanish
  "fr", // French
  "de", // German
  "vi", // Vietnamese
  "th", // Thai
  "id", // Indonesian
  "ru", // Russian
  "pt", // Portuguese
  "it", // Italian
  "ar", // Arabic
  "hi", // Hindi
  "ms", // Malay
  "tl", // Tagalog
] as const;

export const ALL_ISO639_1 = [
  "aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az",
  "ba", "be", "bg", "bi", "bm", "bn", "bo", "br", "bs",
  "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy",
  "da", "de", "dv", "dz",
  "ee", "el", "en", "eo", "es", "et", "eu",
  "fa", "ff", "fi", "fj", "fo", "fr", "fy",
  "ga", "gd", "gl", "gn", "gu", "gv",
  "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz",
  "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu",
  "ja", "jv",
  "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky",
  "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv",
  "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my",
  "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny",
  "oc", "oj", "om", "or", "os",
  "pa", "pi", "pl", "ps", "pt",
  "qu",
  "rm", "rn", "ro", "ru", "rw",
  "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw",
  "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty",
  "ug", "uk", "ur", "uz",
  "ve", "vi", "vo",
  "wa", "wo",
  "xh",
  "yi", "yo",
  "za", "zh", "zu",
] as const;

export type IsoLanguageCode = typeof ALL_ISO639_1[number];

/** Combined ordered list with popular languages on top followed by remaining unique codes */
export const ISO639_1_ORDERED: readonly string[] = [
  ...POPULAR_ISO639_1,
  ...ALL_ISO639_1.filter((code) => !(POPULAR_ISO639_1 as readonly string[]).includes(code)),
];
